const API_BASE_URL = (process.env.REACT_APP_API_URL || 'https://api.lendingmitra.com').replace(/\/$/, '');

export const CONTACT_INQUIRY_URL = `${API_BASE_URL}/api/lm-send-contact-inquiry`;
